<app-action-default
        #actionDefault
    [formGroup]="formGroup"
    [displayButton]="!hideSendButton"
    [service]="service"
    [buildPayload]="buildPayload"
    (actionError)="toastControl.presentError($event, 'L\'e-mail n\'a pas été envoyé')"
    buttonLabel="Envoyer l'e-mail"
    (actionSuccessfull)="actionDone()">

    <app-card title="E-mail">
        <app-email-content-form
                [initialContent]="initialContent"
                [initialSubject]="initialSubject"
                [initialTo]="initialTo"
                [formGroup]="formGroup"
                [canAddDocuments]="true"
                [formatContentService]="formatContentService"
                [buildFormatContentPayload]="buildFormatContentPayload"
                [partnerId]="partnerId">
        </app-email-content-form>
    </app-card>
    <app-send-email-trigger-form [parentFormGroup]="triggerFormGroup"></app-send-email-trigger-form>
</app-action-default>
